import React, { PureComponent } from 'react';
import ToggleColumnCell from './toggleColumnCell'

export default class MatrixColumnCell extends PureComponent {
  constructor(props){
    super(props)
    this.state = {
      user: props.user,
      planPermission: this.getPlanPermission(props),
    }
  }

  getPlanPermission(props){
    if (props.planPermission && props.planPermission.id){
      return props.planPermission
    }

    return {
      plan_id: props.plan.id,
      user_id: props.user.id,
      can_read: false,
      can_update: false,
    }
  }

  // togglePermissionButton(plan, planPermissionKey, planPermission, e)
  togglePermissionButton = (e) => {
    e.stopPropagation();
    const planPermission = {...this.state.planPermission}
    planPermission.buttonDisabled = true
    this.setState({ planPermission: planPermission })

    let can_read = planPermission.can_read
    let can_update = planPermission.can_update

    if(!can_read && !can_update){
      can_read = true
    } else if ( can_read && can_update ) {
      can_read = false
      can_update = false
    } else if ( can_read ){
      can_update = true
    }

    const params = {}
    if(planPermission.id){ params.id = planPermission.id }
    params.user_id = planPermission.user_id
    params.plan_id = planPermission.plan_id
    params.can_read = can_read
    params.can_update = can_update

    this.props.updatePlanPermission(params).then(()=> {
      if(!this.props.planPermissionError){
        planPermission.can_read = can_read
        planPermission.can_update = can_update
        planPermission.buttonDisabled = false
        this.setState({ planPermission: {...planPermission} })
      }
    });
  }

  render(){
    let className = "button-cell"
    if(this.state.planPermission.buttonDisabled){
      className = "button-cell cursor-wait"
    }
    return <ToggleColumnCell onClick={this.togglePermissionButton} className={className} permission={this.state.planPermission} />
  }
}



// WEBPACK FOOTER //
// ./src/components/userPlanPermissionTable/matrixColumnCell.js